import { Collapse, Divider, Stack, Typography } from "@mui/material"
import { ReactElement } from "react"
import { Control } from "react-hook-form"

import {
    DEMAND_LIMIT_REASON_REG,
    DEMAND_LIMIT_REG,
    GEN_LIMIT_REASON_REG,
    GEN_LIMIT_REG,
    LIMIT_REASONS,
} from "./dnoResponseForm"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import ValidatedCheckBox from "../../inputs/validated/validatedCheckBox"
import ValidatedAutocomplete from "../../inputs/validated/validatedSelect"

// Build array of strings ranging from 4.0 kW to 20 kW in 1 kw increments
const GEN_LIMITS_4_20 = Array.from(
    { length: 17 },
    (_, i) => `${(i + 4).toFixed(1)} kW`
)
const GEN_LIMITS = ["0 kW", "3.68 kW", ...GEN_LIMITS_4_20]
const DEMAND_LIMITS = ["40 A", "50 A", "60 A", "80 A", "100 A"]

interface IGenOrDemandOnlyConditions {
    display: boolean
    control: Control
    isGenMode: boolean
}

/**
 * Displays the conditions for a Gen or Demand only application. Allows user
 * to select the limit and reason for the limit. This is for applications
 * that are approved conditionally.
 */
const GenOrDemandOnlyConditions = ({
    display,
    control,
    isGenMode,
}: IGenOrDemandOnlyConditions): ReactElement => (
    <Collapse in={display}>
        <Stack spacing={GRID_SPACING} marginY={1}>
            <Typography color="text.secondary">
                Please outline the conditions of this approval and reasoning for
                it
            </Typography>
            {isGenMode ? (
                <>
                    <ValidatedAutocomplete
                        control={control}
                        required
                        registerName={GEN_LIMIT_REG}
                        label="Export must be limited to"
                        options={GEN_LIMITS}
                    />
                    <ValidatedCheckBox
                        control={control}
                        required
                        registerName={GEN_LIMIT_REASON_REG}
                        label="Reasons for limiting the export"
                        checkboxOptions={LIMIT_REASONS}
                    />
                </>
            ) : (
                <>
                    <ValidatedAutocomplete
                        control={control}
                        required
                        registerName={DEMAND_LIMIT_REG}
                        label="Import must be limited to"
                        options={DEMAND_LIMITS}
                    />
                    <ValidatedCheckBox
                        control={control}
                        required
                        registerName={DEMAND_LIMIT_REASON_REG}
                        label="Reasons for limiting the import"
                        checkboxOptions={LIMIT_REASONS}
                    />
                </>
            )}

            <Divider />
        </Stack>
    </Collapse>
)

export default GenOrDemandOnlyConditions
